import { useEffect } from "react";
import { useParams } from "react-router";
import { signal } from "@preact/signals-react";

import SectionNoData from "components/Tools/SectionNoData";
import LoadingIcon from "components/Tools/LoadingIcon";
import proxy from "api/proxy";
import { getStorage } from "store/local";
import hotels from "ext-apps/WebBookingHotel/infoHotels";

const notConfigured = signal(false);

function WebBooking() {
  const { date } = useParams();

  useEffect(() => {
    redirectToEngine();
  }, []);

  async function redirectToEngine() {
    const ctxSession = getStorage("ctxVirtualSession");
    let bookingUrl = hotels[ctxSession?.db]?.bookingEngineUrl;
    if (!bookingUrl) {
      const { data } = await proxy.search(
        "hotel.configuration",
        ["id", "=", ctxSession?.company],
        ["web_booking_url"],
      );
      bookingUrl = data?.[0]?.web_booking_url;
    }
    const baseUrl = (bookingUrl || "").replace(/\/+$/, "");
    if (!URL.canParse(`${baseUrl}/`)) {
      notConfigured.value = true;
      return;
    }
    const target = new URL(`${baseUrl}/`);
    const params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      target.searchParams.set(key, value);
    });
    if (date && !target.searchParams.has("date")) {
      target.searchParams.set("date", date);
    }
    target.hash = window.location.hash;
    window.location.replace(target.toString());
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      {notConfigured.value ? (
        <SectionNoData text="Booking engine URL is not configured" />
      ) : (
        <LoadingIcon size="40px" />
      )}
    </div>
  );
}

export default WebBooking;
